export default __webpack_public_path__ + "assets/images/ilustracao-cadastro-aprovado5b4423d965b9d17c2dcff9a8db97ab50.png";